module.exports = __webpack_public_path__ + "static/media/coders.645126f6.png";